import { useEffect, useState } from 'react';

const useChangeCounterValue = counter => {
  // this code for check last counter tha come from backend
  const [lastCounter, setLastCounter] = useState(0);

  useEffect(() => {
    // setLastCounter(data?.response_data.counter);
    setLastCounter(counter);
  }, [counter]);

  return { lastCounter };
};

export default useChangeCounterValue;
